// Sample Form Trigger - Opens the popup (original functionality)
if (!customElements.get('sample-form-trigger')) {
  customElements.define(
    'sample-form-trigger',
    class SampleFormTrigger extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback() {
        const popupTriggers = this.querySelectorAll("[data-form-open]");
        
        popupTriggers.forEach((trigger) => {
          trigger.addEventListener("click", this.onOpenFormClick.bind(this));
        });
      }

      async onOpenFormClick(e) {
        e.preventDefault();

        const html = await window
          .fetchSection(
            `/products/${this.dataset.productHandle}?section_id=product-sample`
          )
          .then((section) => section.innerHTML);

        this.popupMaxHeight = this.dataset.popupMaxHeight ? this.dataset.popupMaxHeight : "";
        this.popupMaxWidth = this.dataset.popupMaxWidth ? this.dataset.popupMaxWidth : "";

        this.popup = new window.Popup(html, this.popupMaxWidth, this.popupMaxHeight);
      }
    }
  );
}

// Sample Form - Handles Klaviyo submission
if (!customElements.get('sample-form')) {
  class SampleForm extends HTMLFormElement {
    constructor() {
      super();
      console.log('SampleForm constructor called for:', this);
      console.log('Form location:', this.closest('*'));
      console.log('Form visible:', this.offsetParent !== null);
      console.log('Form dataset:', this.dataset);
      this.addEventListener('submit', this.handleSubmit.bind(this));
    }

    get submitButton() {
      return (
        this._submitButton ||
        (this._submitButton = this.querySelector('[type="submit"]'))
      );
    }

    handleSubmit(event) {
      console.log('🚨 FORM SUBMIT HANDLER CALLED!', event);
      event.preventDefault();
      
      const formData = new FormData(this);
      const email = formData.get('email');
      
      console.log('Form data collected:', Object.fromEntries(formData.entries()));
      console.log('Email value:', email);
      console.log('Email type:', typeof email);
      console.log('Email truthy?', !!email);
      
      if (!email) {
        console.log('❌ No email found, returning early');
        return;
      }
      
      console.log('✅ Email validation passed, continuing...');

      console.log('🔑 Checking for Klaviyo API key...');
      console.log('window.theme:', window.theme);
      console.log('window.theme?.settings:', window.theme?.settings);
      console.log('window.klaviyo_api_key:', window.klaviyo_api_key);
      
      const klaviyoApiKey = window.theme?.settings?.klaviyo_api_key || window.klaviyo_api_key;
      const klaviyoRevision = window.theme?.settings?.klaviyo_revision || window.klaviyo_revision || '2025-10-15';

      console.log('Final klaviyoApiKey:', klaviyoApiKey);
      console.log('Final klaviyoRevision:', klaviyoRevision);

      if (!klaviyoApiKey || klaviyoApiKey === false) {
        console.warn('❌ Klaviyo API key not found');
        this.showErrorMessage();
        return;
      }
      
      console.log('✅ API key found, proceeding with form submission...');

      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('btn--loading');

      // Collect all form data for event properties
      const properties = {
        product_title: this.dataset.productTitle || '',
        product_url: this.dataset.productUrl || window.location.href,
        first_name: formData.get('first_name') || '',
        last_name: formData.get('last_name') || '',
        phone: formData.get('Phone') || '',
        company_name: formData.get('company_name') || '',
        address1: formData.get('address1') || '',
        address2: formData.get('address2') || '',
        city: formData.get('city') || '',
        state: formData.get('state') || '',
        postcode: formData.get('postcode') || '',
        country: formData.get('country') || '',
        accepts_marketing: formData.get('accepts_marketing') === 'true',
        accepts_tsandcs: formData.get('accepts_tsandcs') === 'true'
      };

      this.pushKlaviyoEvent(email, properties);
    }

    showSuccessMessage() {
      const template = document.getElementById('sample-success-message');
      if (template) {
        const message = template.content.cloneNode(true);
        this.innerHTML = '';
        this.appendChild(message);
      }
    }

    showErrorMessage() {
      const template = document.getElementById('sample-error-message');
      if (template) {
        const message = template.content.cloneNode(true);
        this.innerHTML = '';
        this.appendChild(message);
      }
      
      // Re-enable submit button on error
      if (this.submitButton) {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('btn--loading');
      }
    }

    pushKlaviyoEvent(email, properties) {
      const klaviyoApiKey = window.theme?.settings?.klaviyo_api_key || window.klaviyo_api_key;
      const klaviyoRevision = window.theme?.settings?.klaviyo_revision || window.klaviyo_revision || '2024-10-15';

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: klaviyoRevision,
          'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: {
                data: {
                  type: 'metric',
                  attributes: {
                    name: 'Sample Request'
                  }
                }
              },
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: properties.first_name,
                    last_name: properties.last_name,
                    phone_number: properties.phone
                  }
                }
              },
              properties: properties
            }
          }
        })
      };

      console.log('Sending Klaviyo event with:', {
        apiKey: klaviyoApiKey,
        revision: klaviyoRevision,
        properties: properties,
        email: email
      });

      fetch(
        `https://a.klaviyo.com/client/events/?company_id=${klaviyoApiKey}`,
        options
      )
        .then((response) => {
          console.log('Klaviyo response status:', response.status);
          console.log('Klaviyo response headers:', response.headers);
          
          if (response.status === 202) {
            console.log('✅ Klaviyo event successfully tracked!');
            this.showSuccessMessage();
          } else {
            return response.text().then(text => {
              console.error('Klaviyo API error response:', text);
              throw new Error(`HTTP ${response.status}: ${text}`);
            });
          }
        })
        .catch((error) => {
          console.error('Klaviyo event tracking failed:', error);
          console.error('Error details:', {
            message: error.message,
            stack: error.stack,
            apiKey: klaviyoApiKey,
            revision: klaviyoRevision
          });
          this.showErrorMessage();
        });
    }
  }

  customElements.define('sample-form', SampleForm, {
    extends: 'form'
  });
}
